"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UnconstrainedFlyOverSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path d="m22.648 7.516-5.73-5.174a1.404 1.404 0 0 0-1.836 0l-5.73 5.174a2.744 2.744 0 0 0-.89 2.016v8.372c0 .733.613 1.327 1.37 1.327h12.336c.757 0 1.37-.594 1.37-1.327V9.532c0-.761-.321-1.49-.89-2.016Z"></path><path d="M6.422 13.732C3.7 15.108 2 17.063 2 19.232c0 3.756 5.103 6.871 11.78 7.444l-2.57 1.285a1.077 1.077 0 0 0 .964 1.926l4.535-2.267c1.588-.794 1.588-3.06 0-3.853l-4.535-2.268a1.077 1.077 0 0 0-.963 1.927l2.07 1.035c-2.44-.284-4.565-.937-6.16-1.795-2.25-1.212-2.967-2.525-2.967-3.434 0-.808.566-1.934 2.268-3.024v-2.475Z"></path><path d="M27.846 19.23c0-.806-.564-1.928-2.258-3.017v-2.475C28.304 15.113 30 17.065 30 19.23c0 2.652-2.545 4.985-6.392 6.329a1.098 1.098 0 1 1-.54-2.087l-.001-.007a13.56 13.56 0 0 0 1.811-.801c2.25-1.212 2.968-2.525 2.968-3.434Z"></path></g>';
var UnconstrainedFlyOverSVG = function UnconstrainedFlyOverSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.UnconstrainedFlyOverSVG = UnconstrainedFlyOverSVG;
UnconstrainedFlyOverSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(UnconstrainedFlyOverSVG);
exports.default = _default;